import { createAppRequest } from '@/services/request';
import type { ApiRequestOptions } from './types/common';
import type {
  FamsHoldingAnalysisItem,
  FamsHoldingAnalysisListResponse,
  FamsHoldingAnalysisOptionsResponse,
  FamsHoldingAnalysisQueryParams,
  FamsHoldingAnalysisSummaryResponse,
} from './types/holding-analysis';

const request = createAppRequest();

export async function getFamsHoldingAnalysisOptions(
  params?: FamsHoldingAnalysisQueryParams,
  options?: ApiRequestOptions,
) {
  return request<FamsHoldingAnalysisOptionsResponse>('/bff/fams/holding-analysis/options', {
    method: 'GET',
    params,
    ...(options || {}),
  });
}

export async function getFamsHoldingAnalysisSummary(
  params?: FamsHoldingAnalysisQueryParams,
  options?: ApiRequestOptions,
) {
  return request<FamsHoldingAnalysisSummaryResponse>('/bff/fams/holding-analysis/summary', {
    method: 'GET',
    params,
    ...(options || {}),
  });
}

export async function getFamsHoldingAnalysisList(
  params?: FamsHoldingAnalysisQueryParams,
  options?: ApiRequestOptions,
) {
  return request<FamsHoldingAnalysisListResponse>('/bff/fams/holding-analysis/list', {
    method: 'GET',
    params,
    ...(options || {}),
  });
}

export async function getFamsHoldingAnalysisDetail(
  id: string,
  params?: Pick<FamsHoldingAnalysisQueryParams, 'snapshotDate' | 'viewMode'>,
  options?: ApiRequestOptions,
) {
  return request<FamsHoldingAnalysisItem>(`/bff/fams/holding-analysis/${id}`, {
    method: 'GET',
    params,
    ...(options || {}),
  });
}
